module.exports = __webpack_public_path__ + "img/logo2.3d1bcd41.png";